// extracted by mini-css-extract-plugin
export default {"nextAvailableMarker":"nextAvailableMarker_nextAvailableMarker__66wkZ","selected":"nextAvailableMarker_selected__+lAND"};